if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('#AgreeToTos');

      if (this.checkbox) {
        this.#toggleCheckoutButton();

        this.checkbox.addEventListener('change', () => {
          this.#toggleCheckoutButton();
        });

        // Browsers restore a checkbox's checked state on back/forward
        // navigation (and bfcache restores) without firing a 'change'
        // event, so relying on 'change' alone leaves the Checkout button
        // stuck disabled while the box visually shows ticked. 'pageshow'
        // fires after that restoration on both a fresh load and a
        // bfcache restore, so re-sync from the checkbox's real state
        // there too.
        window.addEventListener('pageshow', () => {
          this.#toggleCheckoutButton();
        });
      }
    }

    #toggleCheckoutButton() {
      document.querySelectorAll('#CheckOut').forEach(button => {
        button.disabled = !this.checkbox.checked;
      });
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}